<template>
    <div>
        <p class="caption">Loading, please wait...</p>
        <div class="columns is-variable is-8">
            <div class="column is-narrow">
                <span class="SkeletonBox p"/>
                <br>
                <span class="SkeletonBox h"/>
            </div>
            <div class="column is-narrow">
                <span class="SkeletonBox p"/>
                <br>
                <span class="SkeletonBox h"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "loader"
    }
</script>

<style scoped lang="scss">
    .SkeletonBox {
        display: inline-block;
        position: relative;
        overflow: hidden;
        vertical-align: middle;
        background-color: #DDDBDD;

          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            transform: translateX(-100%);
            background-image: linear-gradient(
              90deg,
              rgba(#fff, 0) 0,
              rgba(#fff, 0.2) 20%,
              rgba(#fff, 0.5) 60%,
              rgba(#fff, 0)
            );
            animation: shimmer 5s infinite;
            content: '';
          }

      @keyframes shimmer {
        100% {
          transform: translateX(100%);
        }
      }
    }

    .p {
        width: 120px;
        height: 16px;
    }

    .h {
        width: 280px;
        height: 72px;
    }
</style>